const slick = require("slick-carousel");
const Gallery = function(){
	
	const slickGalleryWebdoor = function (el) {

		let $elmGalleryWebdoor 	= $(el);
		let totimagesWebdoor 	= 0;

		$elmGalleryWebdoor.slick({
			//appendArrows : $navWebdoor,
			//prevArrow : '<button class="ico svg ico-gallery-arrow-left"></button>',
			//nextArrow : '<button class="ico svg ico-gallery-arrow-right"></button>',
			autoplay : true,
			infinite: true,
			autoplaySpeed : 5000,
			cssEase: 'cubic-bezier(0.27, 0.16, 0, 1.01)',
			speed : 1600,
			pauseOnHover : false,
			pauseOnFocus : false
		});
	}

	const slickGallery = function (el) {
		
		$(el).each(function () {
			var _this = $(this);

			_this.slick({
				autoplay : true,
				infinite: true,
				autoplaySpeed : 5000,
				cssEase: 'cubic-bezier(0.27, 0.16, 0, 1.01)',
				speed : 1600,
				pauseOnHover : false,
				pauseOnFocus : false,
				dots : true	
			});

		})

	};

	const slickGalleryZoom = function (el) {
		
		$(el).each(function () {
			var _this = $(this);

			_this.slick({
				prevArrow : '<button class="ico svg ico-gallery-arrow-left"></button>',
				nextArrow : '<button class="ico svg ico-gallery-arrow-right"></button>',
				autoplay : false,
				infinite: false, // galerias com zoom nao podem ser infinitas
				autoplaySpeed : 5000,
				cssEase: 'cubic-bezier(0.27, 0.16, 0, 1.01)',
				speed : 1600,
				pauseOnHover : false,
				pauseOnFocus : false,
				slidesToShow: 3,
				slidesToScroll: 1	
			});

		})

	};


	return {
		init : function () {
			
			if( $(".slick-webdoor").length > 0 ) { slickGalleryWebdoor(".slick-webdoor"); }
			if( $(".slick-gallery").length > 0 ) { slickGallery(".slick-gallery"); }
			if( $(".slick-gallery-zoom").length > 0 ) { slickGalleryZoom(".slick-gallery-zoom"); }

		}
	}

}();

module.exports = Gallery;